export default "__VITE_ASSET__CCuDrSDx__"